import { useQuery } from 'react-query';
import { APIErrorType } from '../../api';
import { fetchPackageTypes, PackageTypeType } from '../../api/package-type';
import { UseQueryResult } from 'react-query/types/react/types';

export type usePackageTypesReturnType = UseQueryResult<PackageTypeType[]>;

export function usePackageTypes(): usePackageTypesReturnType {
  return useQuery<PackageTypeType[], APIErrorType, PackageTypeType[], string>(
    'package-types',
    fetchPackageTypes,
    { staleTime: 60 * 1000 }
  );
}
